import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import AppContainer from 'components/AppContainer';
import ResourceItemSmall from 'components/ResourceItemSmall';
import SectionTitle from 'containers/TopicCenter/components/SectionTitle';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '54px',
  },

  gridWrapper: {
    marginTop: '10px',
  },
}));

function PersonalizationList({ grayscale, item, linkLabel, trackingPath }) {
  const classes = useStyles();
  const resources = _get(item, 'fields.resources', []);

  if (_isEmpty(resources)) return null;

  const hasTopicsOnly =
    resources.filter(
      resource => _get(resource, 'sys.contentType.sys.id') === 'topic',
    ).length === resources.length;
  return (
    <div className={classes.root}>
      <AppContainer id="personalization-list">
        <Grid container>
          <Grid item xs={12}>
            <SectionTitle
              title={_get(item, 'fields.title')}
              link={hasTopicsOnly ? '/topics' : undefined}
              linkLabel={linkLabel}
            />
          </Grid>
          <Grid item xs={12} className={classes.gridWrapper}>
            <Grid container spacing={2}>
              {resources.map(resource => (
                <Grid item xs={12} sm={6} md={4} key={_get(resource, 'sys.id')}>
                  <ResourceItemSmall
                    item={resource.fields}
                    route={
                      _get(resource, 'sys.contentType.sys.id') === 'topic'
                        ? '/topics'
                        : '/lists'
                    }
                    personalizedCard
                    type={
                      _get(resource, 'sys.contentType.sys.id') === 'topic'
                        ? 'topic'
                        : 'list'
                    }
                    grayscale={grayscale}
                    trackingPath={trackingPath}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </AppContainer>
    </div>
  );
}

PersonalizationList.propTypes = {
  grayscale: PropTypes.bool,
  item: PropTypes.object,
  linkLabel: PropTypes.string,
  trackingPath: PropTypes.string,
};

export default PersonalizationList;
